<template>
  <div class="equ-mior">
    <custom-plane>
      <div class="whole">
        <div class="equ_top">
          <div class="block"></div>
          <div>ACT-1-W</div>
        </div>
        <div class="top_right">
          <div class="right_data">
            <div class="top_text">电梯状态</div>
            <div class="top_value normal">正常</div>
          </div>
          <div class="right_data">
            <div class="top_text">运行状态</div>
            <div class="top_value">上行中</div>
          </div>
          <div class="right_data">
            <div class="top_text">电梯当前楼层</div>
            <div class="top_value floor">1F</div>
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.equ-mior {
  margin-top: 20px;
  width: 100%;
  height: 172px;

  .whole {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    margin-top: 20px;

    .equ_top {
      display: flex;
      align-items: center;
      height: 33px;
      font-size: 22px;
      .block{
        width: 8px;
        height: 8px;
        background-color: #D9D9D9;
        margin-right: 10px;
      }
    }

    .top_right {
      width: 377px;
      height: 57px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      text-align: center;

      .right_data {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 57px;
        letter-spacing: 1px;

        .top_text {
          font-size: 14px;
          color: rgba(229, 229, 229, 0.7);
        }

        .top_value {
          font-size: 18px;
          font-weight: 500;
        }

        .normal {
          color: #2d82ff;
        }

        .floor {
          font-size: 24px;
          font-family: "dina";
        }
      }
    }
  }
}
</style>
